import { atom } from "jotai";
import { MaybeString } from "utils/types";

const rawSelectedComponentAtom = atom<MaybeString>(null);
export const selectedComponentAtom = atom<
  MaybeString,
  MaybeString | ((prev: MaybeString) => MaybeString)
>(
  (get) => {
    const selectedComponentId = get(rawSelectedComponentAtom);
    return selectedComponentId;
  },
  (_, set, arg) => {
    return set(rawSelectedComponentAtom, arg);
  }
);
